import React, { Component, Fragment } from 'react';
import './index.css';
import { reactTranslateChangeLanguage } from 'translate-components';
import Helmet from 'react-helmet-async';
import Countdown from 'react-countdown';
const elements = [
    {
        option: "django",
        content: 'django admin',
        price: '150'
    },
    {
        option: "telegram",
        content: 'Telegram',
        price: '50'
    },
    {
        option: "cta",
        content: 'CTA module with timer',
        price: '50'
    },
    {
        option: "animations",
        content: 'Animations',
        price: '220'
    }

]
const options = [
    {
        name: "django",
        title: "Админ-панель",
        descr: "Редактируйте тексты на сайте и добавляйте промо-акции.",
        price: "150"
    },
    {
        name: "telegram",
        title: "Заявки в Telegram",
        descr: "Реагируйте быстрее",
        price: "50"
    },
    {
        name: "cta",
        title: "CTA с таймером",
        descr: "Реагируй быстрее",
        price: "50"
    },
    {
        name: "animations",
        title: "Анимации",
        descr: "Крутые анимации",
        price: "50"
    }
]


export default class Pricing extends Component {
    constructor() {
        super();
        this.state = {
            result: {},
            price: '',
            options: [],
            totalPrice: '',
            blockCount: 1,
            type: 'landing',
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.setState({totalPrice: 200});
    }
    handlePlus= e => {
        this.setState({blockCount: (this.state.blockCount + 1)})
    }
    handleMinus= e => {
        if ( this.state.blockCount > 1 ){
        this.setState({blockCount: (this.state.blockCount - 1)})
        }
    }
    handleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        const checked = e.target.checked;
        this.setState(prevstate => {
            const newState = {...prevstate};
            if (checked) {
                newState['options'] = [...prevstate.options, name]
                newState['totalPrice'] = Number(this.state.totalPrice) + Number(value);
            } else {
                let array = [...this.state.options];
                let index = array.indexOf(name)
                if (index !== -1) {
                    array.splice(index, 1);
                    this.setState({options: array});
                }
                newState['totalPrice'] = Number(this.state.totalPrice) - Number(value);
            }
            return newState;
        })
    };
    componentDidUpdate() {
        reactTranslateChangeLanguage.bind(this, localStorage.getItem('lang'))();
    }
    render() {
        console.log(this.state);
        const products = new Array(this.state.blockCount).fill(null);
        return (<Fragment>

            <Helmet>
                <title> Dside Pricing </title>
            </Helmet>
            <div className="row">
                <section className="step-first">
                    <div className="pricing__wrapper">
                        <div className="row conf-flex">
                            <div>
                                <div className="product-holder">
                                    <div className={'brick active header'}><span className="label">Header (base)</span></div>
                                    <div className={'brick active form'}><span className="label">CTA with form (base)</span></div>
                                    {products.map((value, key) => {
                                        return(
                                        <div className={'brick active product'}><span
                                            className="label">Product (base)</span></div>
                                        )
                                    })}
                                    {elements.map((value, key) => {
                                        const { option, content, price } = value;
                                        return(
                                            <div key={key} className={'brick ' + option + ' ' + (this.state.options.includes(option) && (option !== 'django') && (option !== 'telegram')  ? 'active':'')}><span className="label">{content} ( <b>+ {price}</b> )</span><div className='brick-content'> {option === 'cta' ? <div><h4>Акция</h4><Countdown date={Date.now() + 111001000}/></div>:''}</div></div>
                                        )
                                    })}
                                    <div className={'brick active footer'}><span className="label">Footer (base)</span></div>
                                </div>
                            </div>

                            <div>
                                <h2>Landing Page за <span>{this.state.totalPrice}</span></h2>
                                <span>Написан на {this.state.options.includes('django') ? 'Python (Framework Django)':'Html'}</span>
                                <span>1 блок с описанием товара</span>
                                <span>Форма сбора заявок</span>
                                <span>Заявки отправляются {this.state.options.includes('telegram') ? 'в Telegram':'на почту'}</span>
                                <hr/>
                                <div className="apple-switch">
                                    {options.map((value, key) => {
                                        const { name, price, title, descr } = value;
                                        return(
                                            <label htmlFor={name} key={key}>
                                                <input type="checkbox" className="apple-switch" onChange={this.handleChange} id={name} name={name} value={price} />
                                                <i></i>
                                                <span>{title}
                                                    <small>{descr}</small></span>
                                            </label>
                                        )
                                    })}
                                </div>
                                <span onClick={this.handleMinus}>-</span>
                                <input type="text" onChange={this.handleChange} id="block-count" name="block-count" value={this.state.blockCount} />
                                <span onClick={this.handlePlus}>+</span>
                                <button className='btn btn-send'>Дайте две</button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </Fragment>);
    }
}



// WEBPACK FOOTER //
// ./src/components/DynamicContent/Configurator/index.jsx